import { render, staticRenderFns } from "./EmDictTypeEdit.vue?vue&type=template&id=695ad794&"
import script from "./EmDictTypeEdit.vue?vue&type=script&lang=js&"
export * from "./EmDictTypeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports